// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Trapezoid.View'
    , [
        'calculator_square_foot_trapezoid.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_trapezoid_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_trapezoid_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-trapezoid"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var baseOne = $('#square-foot-trapezoid-base-one').val(),
                    baseTwo = $('#square-foot-trapezoid-base-two').val(),
                    height = $('#square-foot-trapezoid-height').val();
                //output fields
                var area = $('#square-foot-trapezoid-area');

                var result = ((parseFloat(baseOne) + parseFloat(baseTwo)) / 2) * parseFloat(height);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-trapezoid-input-fields').find('input:text').val('');
                $('.calculator-square-foot-trapezoid-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
